import { render, staticRenderFns } from "./CartInfoCardWrapper.vue?vue&type=template&id=5a8d633c"
import script from "./CartInfoCardWrapper.vue?vue&type=script&lang=js"
export * from "./CartInfoCardWrapper.vue?vue&type=script&lang=js"
import style0 from "./CartInfoCardWrapper.vue?vue&type=style&index=0&id=5a8d633c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports